import { Component, OnInit } from '@angular/core';
import { GridOptions, GridApi } from 'ag-grid-community';
import { Router, ActivatedRoute } from '@angular/router';
import { AssignDialogComponent } from 'src/app/common/assign-dialog/assign-dialog.component';
import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { printMessage } from 'src/app/constants/service.constants';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { WithdrawComponent } from 'src/app/common/withdraw/withdraw.component';
import { RouteComponent } from 'src/app/common/route/route.component';
import { RequestTypeModalComponent } from '../grants-applications/request-type-modal/request-type-modal.component';
import { GM_APP, ModuleMenu } from 'src/app/models/common';
import { CommonService } from 'src/app/services/common.service';
import { HeadService } from 'src/app/services/common/headservice';
import { UserService } from 'src/app/services/user.service';
import { DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { IstDataShareService } from '../../services/ist/ist-datashare.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SubscriptionLike } from 'rxjs';
import { ApidataRequestService } from 'src/app/services/apidata-request.service';
import { GrantsDatashareService } from 'src/app/services/grants/grants-datashare.service';
import { UserInstructionModalComponent } from '../grants-applications/user-instruction-modal/user-instruction-modal.component';
import { Organization } from 'src/app/models/um/organization';

@Component({
  selector: 'app-grants-my-applications',
  templateUrl: './grants-my-applications.component.html',
  styleUrls: ['./grants-my-applications.component.scss']
})
export class GrantsMyApplicationsComponent implements OnInit {
  collapesedOrNot: boolean;
  gridApi: GridApi;
  columnDefs;
  operations;
  alloperations;
  rowData;
  advanceSearch;
  selectedRow;
  caseDetails;
  grantsapp: GM_APP;
  grants: GM_APP[];
  userType: string = "";
  menudata: ModuleMenu;
  screentoopen: string;
  grantsForm: UntypedFormGroup;
  TheraputicAreaList: any;
  StatusList;any;
  GrantTypeList: any;
  GrandTypeList: Array<any> = [];
  IsOnlyGrandType: boolean = false;
  subGetData: SubscriptionLike;
  constructor(
    private router: Router,
    public routerr: ActivatedRoute,
    private summaryService: GrantsSummaryService,
    private commonService: CommonService,
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private header: HeadService,
    private dataShare: GrantsDatashareService,
    private userService: UserService,
    public apiService: ApidataRequestService,
    private grantsDataShare: GrantsDatashareService
  ) {

  }
  orgdetails: Organization
  ngOnInit() {
    this.StatusList= [{ "value": "", "label": "All" },{ "value": "1", "label": "Draft" }, { "value": "2", "label": "Submitted" }, { "value": "3", "label": "Review Ongoing" }, { "value": "4", "label": "Accepted" }, { "value": "5", "label": "Closed" }, { "value": "6", "label": "Rejected" }, { "value": "7", "label": "On-hold" }, { "value": "8", "label": "Withdrawn" }, { "value": "9", "label": "Discarded" }];
    this.collapesedOrNot = false;
    this.userType = this.userService.getUserType();
    let orgcode = this.userService.getOrgCode();
 this.orgdetails  = this.commonService.getOrganizationObject(orgcode);
    this.setDefaultData();

    this.grantsForm = new UntypedFormGroup({
      APPLICATIONID: new UntypedFormControl(""),
      GRANT_TYPE: new UntypedFormControl(""),
      TITLE: new UntypedFormControl(""),
      THERAPEUTICAREA: new UntypedFormControl(""),
      STATUS: new UntypedFormControl(""),
      DATEFROM: new UntypedFormControl(""),
      DATETO: new UntypedFormControl(""),
      TYPE: new UntypedFormControl("M")
    });
    var formData = this.grantsForm.value;
    this.setSearchSummary(formData);
    this.GetMasterData();
  }

  setSearchSummary(formData) {
    this.summaryService.getGrantAppAdvSearch("api/gmapp/getadvsearch", formData).subscribe(data => {
      this.grants = data;
    });
  }

  setDefaultData() {



    if (this.userType === "E") {
      this.advanceSearch = {
        "fields": [
          {
            "label": "Application ID",
            "field": "simple",
            "type": "text"
          },
          {
            "label": "Grant Type",
            "field": "Grant_type",
            "type": "dropdown"
          },
          {
            "label": "Therapeutic Area",
            "field": "TherapeuticArea",
            "type": "dropdown",
            "options":this.TheraputicAreaList,
          },
          {
            "label": "Status",
            "field": "status",
            "type": "dropdown"
          },
          {
            "label": "Submitted From Date",
            "field": "DATEFROM",
            "type": "date"
          },
          {
            "label": "Submitted To Date",
            "field": "DATETO",
            "type": "date"
          }
        ],
        "filters": []
      }
      this.columnDefs = [
        {
          "headerName": "Application ID",
          "field": "APPLICATION_CODE"
        },
        {
          "headerName": "Grant Type",
          "field": "GRANTTYPE"
        },
        {
          "headerName": "Therapeutic Area",
          "field": "TherapeuticArea"
        },
        {
          "headerName": "Submitted On",
          "field": "SubmittedOnStr"
        },
        {
          "headerName": "Status",
          "field": "StatuStr"
        },
        {
          "headerName": "Assigned To",
          "field": "AssignedStr"
        },
        {
          "headerName": "Last Updated On",
          "field": "UpdateDateStr"
        }
      ];
      this.alloperations = [
        {
          "name": "New Application",
          "id": "add"
        }
      ]
        this.caseDetails = [
          {
            "caseSet": {
              "caseHeading": "",
              "caseData": [
                {
                  "label": "Application ID",
                  "value": "APPLICATION_CODE"
                },
                {
                  "label": "Grant Type",
                  "value": "GRANTTYPE"
                },
                {
                  "label": "TherapeuticArea",
                  "value": "TherapeuticArea"
                },
                {
                  "label": "Submitted On",
                  "value": "SubmittedOnStr"
                },
                {
                  "label": "Assigned To",
                  "value": "AssignedStr"
                },
                {
                  "label": "Last Updated On",
                  "value": "UpdateDateStr"
                },
                {
                  "label": "Status",
                  "value": "StatuStr"
                },
                {
                  "label": "Organization Name ",
                  "value": "OrgName"
                },
                {
                  "label": "Tax Status",
                  "value": "TaxStatus"
                },
                {
                  "label": "Institution Tax Number",
                  "value": "TaxID"
                },
                {
                  "label": "Budget Requested",
                  "value": "REQUESTED_AMOUNT"
                },
                {
                  "label": "Budget Allocated",
                  "value": "ALLOCATION_AMOUNT"
                },
                {
                  "label": "Reconciliation Amount",
                  "value": "EXPENDITURE_AMOUNT"
                }
              ]

            }
          }];
    }
    else if (this.userType === "I"){
      this.advanceSearch = {
        "fields": [
          {
            "label": "Application ID",
            "field": "ApplicationID",
            "type": "text"
          },
          {
            "label": "Grant Type",
            "field": "Grant_type",
            "type": "dropdown"
          },
          {
            "label": "Physician Name",
            "field": "PhysicianName",
            "type": "text"
          },
          {
            "label": "Therapeutic Area",
            "field": "TherapeuticArea",
            "type": "dropdown",
            "options":this.TheraputicAreaList,
          },
          {
            "label": "Status",
            "field": "status",
            "type": "dropdown"
          },
          {
            "label": "Submitted From Date",
            "field": "DATEFROM",
            "type": "date"
          },
          {
            "label": "Submitted To Date",
            "field": "DATETO",
            "type": "date"
          }
        ],
        "filters": []
      }
      this.columnDefs = [
        {
          "headerName": "Application ID",
          "field": "APPLICATION_CODE"
        },
        {
          "headerName": "Full Name",
          "field": "FullName"
        },
        {
          "headerName": "Therapeutic Area",
          "field": "TherapeuticArea"
        },
        {
          "headerName": "Grant Type",
          "field": "GRANTTYPE"
        },
        {
          "headerName": "Status",
          "field": "StatuStr"
        },
        {
          "headerName": "Submitted On",
          "field": "SubmittedOnStr"
        },
        {
          "headerName": "Last Updated On",
          "field": "UpdateDateStr"
        }
      ];
      this.alloperations = [];

        this.caseDetails = [
          {
            "caseSet": {
              "caseHeading": "",
              "caseData": [
                {
                  "label": "Organization Name ",
                  "value": "OrgName"
                },
                {
                  "label": "Tax Status",
                  "value": "TaxStatus"
                },
                {
                  "label": "Tax ID",
                  "value": "TaxID"
                },
                {
                  "label": "Application ID",
                  "value": "APPLICATION_CODE"
                },
                {
                  "label": "Full Name",
                  "value": "FullName"
                },
                {
                  "label": "Email ID",
                  "value": "EMail"
                },
                {
                  "label": "Grant Type",
                  "value": "GRANTTYPE"
                },
                {
                  "label": "TherapeuticArea",
                  "value": "TherapeuticArea"
                },
                {
                  "label": "Submitted On",
                  "value": "SubmittedOnStr"
                },
                {
                  "label": "Last Updated On",
                  "value": "UpdateDateStr"
                },
                {
                  "label": "Status",
                  "value": "StatuStr"
                },
                {
                  "label": "Requested Budget",
                  "value": "REQUESTED_AMOUNT"
                },
                {
                  "label": "Approved Budget",
                  "value": "ALLOCATION_AMOUNT"
                },
                {
                  "label": "Reconciliation Amount",
                  "value": "EXPENDITURE_AMOUNT"
                },
                {
                  "label": "Authorized Signer",
                  "value": "AUTH_SIGNER"
                }
              ]
              }
          }];
    }
    this.operations = this.alloperations.map(operation => {
        return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
      });
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    debugger;
    this.summaryService.getGrantSearchSummary("api/common/getgrantsapp/" + event.data["APPLICATION_ID"], null).subscribe(data => {
      this.grantsapp = data;
      let modulecode = "";
      this.commonService.removeLeftMenu();
      if (this.grantsapp.GRANT_TYPE === 1) {
        modulecode = "GRANTSCME";
        this.dataShare.setCMEID(event.data["ID"]);
      }
      else if (this.grantsapp.GRANT_TYPE === 2) {
        modulecode = "GRANTSSPONSORSHIP";
        this.dataShare.setSPONSORSHIPID(event.data["ID"]);
      }
      else if (this.grantsapp.GRANT_TYPE === 3) {
        modulecode = "GRANTSCHARITABLE";
        this.dataShare.setCharityID(event.data["ID"]);
      }
      this.commonService.setGrantsApp(this.grantsapp);
      this.commonService.appId= event.data["APPLICATION_ID"];
      this.commonService.ScreenID= event.data['ID'];
      this.menudata = new ModuleMenu();
      this.menudata.module = modulecode;
      this.menudata.appId=event.data["APPLICATION_ID"];
      this.menudata.screenID = event.data['ID'];
      this.menudata.operation = "Edit";

      if (this.grantsapp.STATUS === null)
        this.menudata.formstate = "Draft";
      else
        this.menudata.formstate = this.commonService.getStatus(this.grantsapp.STATUS);
      this.commonService.setModluleMenu(this.menudata);
      this.header.setHeader(this.menudata);
      this.dataShare.setGrantApplicationID(event.data["APPLICATION_ID"]);
      this.router.navigate(['/home/grants/my-applications/application-ext/:' + event.data["APPLICATION_ID"] + '/' + this.grantsapp.StartMenu], { skipLocationChange: true, queryParams: { module: "grants",submodule:modulecode, id: event.data['ID'], app_ext: true, screen_type: "my-applications" } })

    });
  }

  assign() {
    this['self'].modalRef = this['self'].modalService.show(AssignDialogComponent,{class: 'modal-md modal-full-height modal-right'});
  }

  print() {
    this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {
      data: {
        operation: { hasOpr: false },
        heading: 'Print Application',
        content: { heading: '', description: printMessage }
      }
    });
  }

  add(){
    this['self'].summaryService.getData("api/common/GetOrgGrantTypes").subscribe(
      (res) => {
        if (res["Status"]) {
          let submodules=[];
          let IsCHARITY = res["Data"].CHARITY;
          let IsSPONSERSHIP = res["Data"].SPONSERSHIP;
          let IsCME = res["Data"].CME;
          if(IsCHARITY)
          {
            submodules.push(3);
          }
          if(IsSPONSERSHIP)
          {
            submodules.push(2);
          }
          if(IsCME)
          {
            submodules.push(1);
          }
          if(submodules.length>1)
          {
            let modalRef1 = this['self'].modalService.open(RequestTypeModalComponent, {
              backdrop: false,
              keyboard: false,
              windowClass: 'modal-lg right modal-right',
              animation: true
            });
          }
          else{
            if(submodules.length>0)
            {
              this['self'].openGrantsUserInstructions(submodules[0]);
            }
          }
        } 
      }
    );
   
  }
  openGrantsUserInstructions(type: any) {
    let Instruction_Status=false;
    let instructionid = "6"
    if (type === 1)
      instructionid = "6";
    else if (type === 2)
      instructionid = "10";
    else if (type === 3)
      instructionid = "8";
    this.summaryService.getInstruction(instructionid).subscribe(summary => {
      let instruction = summary;
      if (instruction != null) {
        Instruction_Status = instruction.SHOWINSTRUCTIONTOUSER;
      }

      if (Instruction_Status) {
        const modalRef = this.modalService.open(UserInstructionModalComponent, {
          backdrop: false,
          keyboard: false,
          windowClass: 'modal-lg right modal-right',
          animation: true
        });
        modalRef.componentInstance.Content = {
          heading: 'Add',
          content: null,
          id: "",
          rtype: type
        }
      }
      else {
        var rtype = type;
        this.commonService.appId = "";
        this.commonService.setGrantsApp(null);
        this.menudata = new ModuleMenu();
        let modulecode = "";
        if (rtype === 1) {
          modulecode = "GRANTSCME";
          this.grantsDataShare.setCMEID("");
        }
        else if (rtype === 2) {
          modulecode = "GRANTSSPONSORSHIP";
          this.grantsDataShare.setSPONSORSHIPID("");
        }
        else if (rtype === 3) {
          modulecode = "GRANTSCHARITABLE";
          this.grantsDataShare.setCharityID("");
        }
        this.commonService.removeLeftMenu();
        this.commonService.appId="";
        this.commonService.ScreenID="";
        this.menudata.module = modulecode;
        this.menudata.operation = "New";
        this.menudata.appId = "";
        this.menudata.formstate = "Draft";
        this.commonService.setModluleMenu(this.menudata);
        this.header.setHeader(this.menudata);
        this.grantsDataShare.setGrantApplicationID("");
        this.summaryService.getGrantSearchSummary("api/common/getgrantsappmain/" + type, null).subscribe(data => {
          debugger;
          this.router.navigate(['/home/grants/my-applications/application-ext/:0/' + data.StartMenu], { skipLocationChange: true, queryParams: { module: "grants",submodule:modulecode, id: 0, app_ext: true, screen_type: "my-applications" } })
        });
      }
    });
  }
  edit(){
    this['self'].router.navigateByUrl('/home/grants/my-applications/application-ext/:'+ this['self'].selectedRow['id']+'/general_information')
  }

  delete(){
    this["self"].modalRef = this["self"].modalService.show(DeleteBoxComponent);
  }
  route() {
    this['self'].modalService.show(RouteComponent,{class: 'modal-md modal-full-height modal-right'});
  }

  return() {
   // this['self'].modalService.show(ReturnComponent,{class: 'modal-md modal-full-height modal-right'});
  }

  reject() {
    // let modalRef = this['self'].modalService.open(RejectComponent, {
    //   backdrop: false,
    //   keyboard: false,
    //   windowClass: 'modal-md right modal-right',
    //   animation: true,

    // });
    // modalRef.componentInstance.Content = {
    //   heading: 'Reject',
    //   content: null
    // }
  }

  onHold() {
    // let modalRef = this['self'].modalService.open(RejectComponent, {
    //   backdrop: false,
    //   keyboard: false,

    //   windowClass: 'modal-md right modal-right',
    //   animation: true,

    // });
    // modalRef.componentInstance.Content = {
    //   heading: 'On-Hold',
    //   content: null
    // }
  }

  release() {
    // let modalRef = this['self'].modalService.open(RejectComponent, {
    //   backdrop: false,
    //   keyboard: false,

    //   windowClass: 'modal-md right modal-right',
    //   animation: true,

    // });
    // modalRef.componentInstance.Content = {
    //   heading: 'Release',
    //   content: null
    // }
  }

  withdraw() {
    this['self'].modalService.show(WithdrawComponent,{class: 'modal-md modal-full-height modal-right'});
  }

  open(){

  }

  close(){

  }

  discard(){

  }

  setSearch() {
    this.SearchClear();
    this.setSearchSummary(this.grantsForm.value);
  }

  //// Advace search Functions
  SearchClear() {
    this.grantsForm = new UntypedFormGroup({
      APPLICATIONID: new UntypedFormControl(""),
      GRANT_TYPE: new UntypedFormControl(""),
      TITLE: new UntypedFormControl(""),
      THERAPEUTICAREA: new UntypedFormControl(""),
      STATUS: new UntypedFormControl(""),
      DATEFROM: new UntypedFormControl(""),
      DATETO: new UntypedFormControl(""),
      TYPE: new UntypedFormControl("M")
    });
  }

  AdvanceSearch() {
    this.setSearchSummary(this.grantsForm.value);
  }

  GetTherapeuticAreas() {
    this.summaryService.getData("api/gmapp/gettherapeuticarealist").subscribe((result) => {
      if (result != null) {
        this.TheraputicAreaList = result;
        this.TheraputicAreaList=  [{label:"Select",value:"-1", checked: true}].concat(this.TheraputicAreaList);

      }
    });
  }

  GetOrgGrantTypes() {
    this.GrantTypeList=[];
    this.subGetData = this.summaryService.getData("api/common/GetOrgGrantTypesForSearch").subscribe(
      (res) => {
       
          this.GrantTypeList=res["Data"];
        
      }
    );
  }
  GetMasterData() {
    this.GetTherapeuticAreas();
    this.GetOrgGrantTypes();
  }
}
